__turbopack_context__.v({
  "blockTitleContainer": "ShopTerrace-module-scss-module__d14gWq__blockTitleContainer",
  "blockTitleContainerMobile": "ShopTerrace-module-scss-module__d14gWq__blockTitleContainerMobile",
  "blocksBackgroundColor": "ShopTerrace-module-scss-module__d14gWq__blocksBackgroundColor",
  "blocksFontColor": "ShopTerrace-module-scss-module__d14gWq__blocksFontColor",
  "container": "ShopTerrace-module-scss-module__d14gWq__container",
  "loadingClassName": "ShopTerrace-module-scss-module__d14gWq__loadingClassName",
  "loadingItem": "ShopTerrace-module-scss-module__d14gWq__loadingItem",
  "secondaryNavBackgroundColor": "ShopTerrace-module-scss-module__d14gWq__secondaryNavBackgroundColor",
  "shopInfoMessage": "ShopTerrace-module-scss-module__d14gWq__shopInfoMessage",
  "themeBackgroundColor": "ShopTerrace-module-scss-module__d14gWq__themeBackgroundColor",
  "themeFontColor": "ShopTerrace-module-scss-module__d14gWq__themeFontColor",
});
